/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Admin Users API
 * Admin bounded-context contract for user aggregate and owned task entity.
 *
 * OpenAPI spec version: 1.0.0
 */
import type {CreateTaskRequest, Task, UpdateTaskRequest} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddTaskUrl = (userId: string) => {
  return `/api/admin/users/${userId}/tasks`;
};

/**
 * Add a new task to a user. This is a convenience endpoint that creates
 * a task and associates it with the user.
 * @summary Add a task to a user
 */
export const addTask = async (
  userId: string,
  createTaskRequest: CreateTaskRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Task> => {
  return customFetch<Task>(getAddTaskUrl(userId), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createTaskRequest),
  });
};

export const getEditTaskUrl = (userId: string, taskId: string) => {
  return `/api/admin/users/${userId}/tasks/${taskId}`;
};

/**
 * Update a task belonging to a user. Only specified fields are updated.
 * @summary Edit a task
 */
export const editTask = async (
  userId: string,
  taskId: string,
  updateTaskRequest: UpdateTaskRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Task> => {
  return customFetch<Task>(getEditTaskUrl(userId, taskId), {
    ...options,
    method: "PATCH",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateTaskRequest),
  });
};

export const getRemoveTaskUrl = (userId: string, taskId: string) => {
  return `/api/admin/users/${userId}/tasks/${taskId}`;
};

/**
 * Delete a task belonging to a user.
 * @summary Remove a task from a user
 */
export const removeTask = async (
  userId: string,
  taskId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveTaskUrl(userId, taskId), {
    ...options,
    method: "DELETE",
  });
};
